// extracted by mini-css-extract-plugin
export default {"Image":"Recipe_Image__WmDjh"};